import { CheckBox, CheckBoxOutlineBlank } from '@mui/icons-material';
import { Button, Stack, Typography } from '@mui/material';
import React from 'react';

interface CheckboxWithLabelProps {
  label: string;
  description?: React.ReactNode;
  checked: boolean;
  setChecked: (v: boolean) => void;
}

export function CheckboxWithLabel(props: CheckboxWithLabelProps) {
  const { label, description, setChecked, checked } = props;
  return (
    <Button
      onClick={() => setChecked(!checked)}
      sx={{
        display: 'flex',
        alignItems: 'center',
        width: 'fit-content',
        py: 1,
        px: 2,
        gap: 1,
        borderRadius: 1,
        textTransform: 'none',
      }}
    >
      {checked ? (
        <CheckBox color="action" />
      ) : (
        <CheckBoxOutlineBlank color="action" />
      )}
      <Stack alignItems="flex-start" ml={description ? 1 : 0} mb={-0.1}>
        <Typography lineHeight={1}>{label}</Typography>
        {description && (
          <Typography
            mt={0.5}
            textAlign="left"
            lineHeight={1}
            variant="body2"
            color="text.secondary"
          >
            {description}
          </Typography>
        )}
      </Stack>
    </Button>
  );
}
